import { useMutation } from 'react-query';
import { MUTATION_KEYS } from '../constants';
import { Timesheet, TimesheetStatus } from '../../types';
import { Http } from '../../services/Http';
import { useInvalidateTimesheets } from './useTimesheets';
import { useInvalidateSingleTimesheet } from './useSingleTimesheet';
import { useInvalidateFilteredOpsTimesheets } from './useFilteredOpsTimesheets';
import { useInvalidateMonthlyTimesheets } from './useMonthlyTimesheets';
import { useInvalidateMonthlySingleTimesheet } from './useMonthlySingleTimesheet';

type SubmitPayload = {
  status: string;
};

type Props = {
  id?: number;
};

const payload = {
  status: TimesheetStatus.ISSUED,
};

async function withdrawTimesheet({ id }: Props): Promise<Timesheet> {
  const { data } = await Http.axios.patch<SubmitPayload, Timesheet>(`/timesheet/${id}`, payload);
  return data;
}
export const useWithdrawTimesheet = () => {
  const invalidateAllTimesheets = useInvalidateTimesheets();
  const invalidateSingleTimesheet = useInvalidateSingleTimesheet();
  const invalidateFilteredOpsTimesheets = useInvalidateFilteredOpsTimesheets();
  const invalidateMonthlyTimesheets = useInvalidateMonthlyTimesheets();
  const invalidateMonthlySingleTimesheet = useInvalidateMonthlySingleTimesheet();
  return useMutation(withdrawTimesheet, {
    mutationKey: MUTATION_KEYS.WITHDRAW_TIMESHEET,
    onSuccess: () => {
      invalidateAllTimesheets();
      invalidateSingleTimesheet();
      invalidateFilteredOpsTimesheets();
      invalidateMonthlyTimesheets();
      invalidateMonthlySingleTimesheet();
    },
  });
};
